import LText from "@components/LText";
import Button from "../common/Button";
import LIcon from "@components/LIcon";
import { presentIntercomSupport } from "@utils/presentIntercomSupport";

const Contact = ({
  width,
  sentryEventName = "AccessDetail.Contact",
}: {
  width: number;
  sentryEventName?: string;
}) => {
  const handleContact = async () => {
    await presentIntercomSupport("present-intercom-from-access-contact");
  };

  return (
    <Button.Button
      onPress={handleContact}
      sentryEventName={sentryEventName}
      bg="whiteTranslucent20"
      width={width}
    >
      <LIcon colors={{ color: "#FFFFFF80" }} name="contact" size={16} />
      <LText variant="Caption/C1/Medium" color="white">
        Contact
      </LText>
    </Button.Button>
  );
};

export default Contact;
